import { createContext, useContext } from 'react'

/**
 * Whether the hosting system modal is currently expanded to full screen.
 * Provided by ModalComponent; lives in its own module (not modal.tsx) so modal
 * content can consume it without importing the modal host back into itself.
 */
export const ModalFullScreenContext = createContext(false)

/** True while the hosting system modal is expanded to full screen. */
export const useModalFullScreen = () => useContext(ModalFullScreenContext)
